var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-box w100 flexCenter"},[_c('div',{staticClass:"w100 flexCenter topBtn"},[_c('div',{staticClass:"dsMainBox dsMainBoxda"},[_c('div'),_vm._v(" "),_c('a',{attrs:{"href":_vm.data.homeUrl}},[_vm._v("返回首页")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }